import React from 'react';
import { Link } from '../../visions/vx-link';
import flyerPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/compressedupdatedglobalrecallsflyer.compressed.pdf';

const AboutPortal = (props) => (
	<div className="container main">
		<h2>A propos du portail</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<iframe width="100%" height="310" src="https://player.vimeo.com/video/170923073" frameBorder="0" allowFullScreen=""/>
			</div>
			<div className="col-sm-6">
				<h4>Qu'est-ce que le <em>portail mondial sur les rappels de produits</em> ?</h4>
				<p>
					Le <em>portail mondial sur les rappels de produits</em> rassemble en un guichet unique, une plateforme de l'OCDE, des informations sur les rappels de produits publiés dans le monde entier,
					collectées sur une base régulière.  Le portail comprend des informations sur les rappels obligatoires ou volontaires de produits de consommation qui ont été émis par des instances publiques,
					ou communiqués à celles-ci, et rendus publics. La portée de ces rappels dépend du mandat de l’instance qui publie l’information.
					Dans certains cas, les rappels peuvent concerner des produits alimentaires, des véhicules, des produits pharmaceutiques et des médicaments.&nbsp;
				</p>
				<p>Le <em>portail mondial sur les rappels de produits</em> a été inauguré le 19 ocotbre 2012.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Qui peut utiliser le portail ?</h4>
				<p>
					Le <em>portail mondial sur les rappels de produits</em> permet d'améliorer le partage de l’information entre les pays et territoires et aide les instances de réglementation
					à prendre des mesures correctives. Tous les pays et territoires dotés de leur propre base de données dédiée aux rappels d’articles électroniques sont invitées à participer au portail.
				</p>
				<p>
					Le portail est également utile aux consommateurs et aux entreprises.
					Les consommateurs peuvent l’utiliser pour vérifier si les produits qu’ils ont l’intention d’acheter posent des problèmes de sécurité, ce qui est particulièrement utile lors d’achats internationaux en ligne.
					Les entreprises sont mieux à même de suivre les risques qui apparaissent dans le monde entier, ce qui peut les aider à agir plus rapidement pour résoudre les problèmes liés à leurs propres produits.
				</p>
				<p>Le portail est une source d’information particulièrement précieuse pour les instances de réglementation, les consommateurs et les entreprises des pays qui ne sont pas dotés de leur propre base de données en ligne dédiée aux rappels de produits de consommation.</p>
			</div>
			<div className="col-sm-6">
				<h4>Quels rappels le portail contient-il ? </h4>
				<p>
					Le <em>portail mondial sur les rappels de produits</em> contient actuellement des rappels de produits de consommation en provenance de 47 pays et territoires du monde entier et inclut les rappels figurant sur les portails régionaux de l’Union européenne et de l’Association des nations de l’Asie du Sud-Est (ASEAN).
					Il est régulièrement mis à jour au moyen de données nouvelles ou historiques fournies par les pays et territoires participants.
				</p>
				<p>
					Il peut y avoir de légères différences dans la définition des types de produits qui correspondent à la définition de « produit de consommation » de chaque pays ou territoire.
					Par exemple, certains pays incluent les cosmétiques dans leurs rappels de produits de consommation, tandis que d’autres peuvent incluent les véhicules.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Comment le portail est-il mis à jour ?</h4>
				<p>
					Chaque pays ou territoire décide de la fréquence et de la date à laquelle il envoie des informations au portail.
					En fonction du système dont il sont dotés, certains envoient ces informations de manière automatisée et d’autres procèdent manuellement. L’intervalle de mise à jour peut varier d’une journée, à une semaine ou à un mois.
				</p>
			</div>
			<div className="col-sm-6">
				<h4>Pendant combien de temps les rappels peuvent-ils être consultés sur le portail ? </h4>
				<p>Les informations sont stockées sur le portail aussi longtemps que chaque pays ou territoire le permet. Certaines informations pourraient donc être disponibles indéfiniment.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Des informations sur les rappels peuvent-elles apparaître sur le portail et ne pas figurer sur le site web dédié aux rappels du pays ou territoire concerné, et inversement ?</h4>
				<p>
					Chaque pays ou territoire participant décide quelles informations sont partagées sur le portail.
					Ainsi, il peut arriver que le site web d’un pays ou territoire contienne des informations plus détaillées concernant un rappel donné.
				</p>
				<p>Toutefois, les pays ou territoires se sont généralement engagées à partager via le portail tous les rappels accessibles au public.</p>
			</div>
		</div>
	</div>
);

export default AboutPortal;



// WEBPACK FOOTER //
// ./src/views/static/fr/about-portal.js